<template>
  <div>
    <!--工具条-->
    <div class="toolbar-container">
      <el-col :span="10">
        <toolbar :buttonList="buttonList" @callFunction="callFunction" :customHandleSearch="customHandleSearch">
        </toolbar>
      </el-col>
      <el-col :span="6">
        <label><span style="width: 60%;">选择考核：</span></label>
        <el-select v-model="defCheck" filterable placeholder="请选择对应考核" @change="checkChange">
          <!-- <el-option :key=0 label="所有考核" :value=0></el-option> -->
          <el-option v-for="item in checks" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <label><span style="width: 60%;">选择模块：</span></label>
        <el-select v-model="defModule" filterable placeholder="请选择对应模块" @change="moduleChange">
          <el-option :key=0 label="所有模块" :value=0></el-option>
          <el-option v-for="item in modules" :key="item.Id" :label="`${item.StIndex} ${item.Stoverview}`"
            :value="item.Id" style="max-width: 500px;" :title="`${item.StIndex} ${item.Stoverview}`">
          </el-option>
        </el-select>
      </el-col>
    </div>

    <!--列表-->
    <el-table ref="multipleTable" :data="checkPoints" tooltip-effect="dark" border v-loading="listLoading"
      style="width: 100%" @selection-change="handleSelectionChange" @row-click="selectCurrentRow" class="custom-tbl">
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" label="序号" width="80"> </el-table-column>
      <el-table-column prop="ReviewPoints" label="评审要点" width="" sortable>
      </el-table-column>
      <el-table-column prop="StIndex" label="标准序号" width="120" sortable :sort-method="customSort">
      </el-table-column>
      <!-- <el-table-column prop="Score" label="标准分值" width="120" sortable>
      </el-table-column> -->
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="200" sortable>
      </el-table-column>
      <el-table-column prop="CreateBy" label="创建者" width="150" sortable>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="handleLook(scope.row.Id)"
            >查看详情</el-button
          > -->
          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 上下页标 -->
    <el-pagination class="toolbar" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="page" :page-size="pageSize" :page-sizes="[10, 20, 50]"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>

    <!-- 查看详情 -->
    <el-dialog title="查看详情" :visible.sync="lookFormVisible" v-model="lookFormVisible" :close-on-click-modal="false"
      :destroy-on-close="true">
      <el-form :model="lookForm" ref="lookForm">
        <el-form-item label="评审要点" prop="ReviewPoints">
          <el-input v-model="lookForm.ReviewPoints" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="标准序号" prop="StIndex">
          <el-input v-model="lookForm.StIndex" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <!-- <el-form-item label="标准分值" prop="Score">
          <el-input v-model="lookForm.Score" auto-complete="off" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="顺序号" prop="SortId">
          <el-input v-model="lookForm.SortId" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-table label="考核细项" ref="table" :data="checkDetails" tooltip-effect="dark" v-loading="detailListLoading"
          border style="width: 100%" class="custom-tbl" :disabled="true">
          <el-table-column type="index" label="序号" width="80">
          </el-table-column>
          <el-table-column prop="ReviewMethod" label="评审方法" width="300" sortable>
          </el-table-column>
          <el-table-column prop="StIndex" label="标准序号" width="" sortable>
          </el-table-column>
          <el-table-column prop="Score" label="标准分值" width="" sortable>
          </el-table-column>
        </el-table>
        <!-- <el-form-item label="状态" prop="IsEnable">
            <el-select v-model="addForm.IsEnable" placeholder="请选择状态">
              <el-option label="激活" value="true"></el-option>
              <el-option label="禁用" value="false"></el-option>
            </el-select>
          </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="lookFormVisible = false">确定</el-button>
      </div>
    </el-dialog>

    <!-- 新增 -->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
      style="width: 1100px; margin: 0 auto;" :destroy-on-close="true">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-col span="24">
            <el-form-item label="所属模块" prop="ModuleId">
              <el-select style="width: 100%" v-model="addForm.ModuleId" filterable placeholder="请选择对应模块"
                @change="getAddStIndex(addForm.ModuleId)">
                <el-option v-for="item in modules" :key="item.Id" :label="`${item.StIndex} ${item.Stoverview}`"
                  :value="item.Id" style="max-width: 500px;" :title="`${item.StIndex} ${item.Stoverview}`">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col span="9">
            <el-form-item label="标准序号" prop="StIndex">
              <el-input style="width: 100%" v-model="addForm.StIndex" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>

          <el-col span="15">
            <el-form-item label="负责人" prop="PersonLiableId" label-width="">
              <el-select style="width: 100%" v-model="addForm.PersonLiableId" filterable placeholder="请选择模块责任人">
                <el-option v-for="item in users" :key="item.UId"
                  :label="`${item.RealName} ${getDeptNameById(item.DepartmentId)} ${item.LoginName}`" :value="item.UId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col span="24">
            <el-form-item label="评审要点" prop="ReviewPoints">
              <el-input style="width : 100%" :rows="5" type="textarea" v-model="addForm.ReviewPoints" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
      style="width: 1800px; margin: 0 auto;" :center="true" :destroy-on-close="true">
      <el-form :model="editForm" :rules="addFormRules" ref="editForm" label-width="80px">
        <el-row>
          <el-col span="24">
            <el-form-item label="所属模块" prop="ModuleId">
          <el-select style="width: 100%" v-model="editForm.ModuleId" filterable placeholder="请选择对应模块"
            @change="getEditStIndex(editForm.ModuleId)">
            <el-option v-for="item in modules" :key="item.Id" :label="`${item.StIndex} ${item.Stoverview}`"
              :value="item.Id" style="max-width: 600px;" :title="`${item.StIndex} ${item.Stoverview}`">
            </el-option>
          </el-select>
        </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col span="9">
            <el-form-item label="标准序号" prop="StIndex">
          <el-input style="width: 100%" v-model="editForm.StIndex" auto-complete="off"></el-input>
        </el-form-item>
          </el-col>

          <el-col span="15">
            <el-form-item label="负责人" prop="PersonLiableId" label-width="">
              <el-select style="width: 100%" v-model="editForm.PersonLiableId" filterable placeholder="请选择模块责任人">
                <el-option v-for="item in users" :key="item.UId"
                  :label="`${item.RealName} ${getDeptNameById(item.DepartmentId)} ${item.LoginName}`" :value="item.UId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col span="24">
            <el-form-item label="评审要点" prop="ReviewPoints">
              <el-input style="width : 100%" :rows="5" type="textarea" v-model="editForm.ReviewPoints" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col span="24">
            <el-form-item label="考核细项">
          <el-button type="primary" @click.native="addDetail(editForm.ModuleId, editForm.Id)">新增</el-button>
          <el-table ref="table" :data="checkDetails" tooltip-effect="dark" v-loading="detailListLoading" border
            style="width: 100%" @row-click="selectCurrentRow" class="custom-tbl">
            <el-table-column type="index" label="序号" width="80">
            </el-table-column>
            <el-table-column prop="ReviewMethod" label="评审方法" width="300" sortable>
            </el-table-column>
            <el-table-column prop="StIndex" label="标准序号" width="" sortable>
            </el-table-column>
            <el-table-column prop="Score" label="标准分值" width="" sortable>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <!-- <el-button
                type="text"
                size="small"
                @click="lookDetail(scope.row.Id)"
                >查看详情</el-button
              > -->
                <el-button type="text" size="small" @click="editDetail(scope.row.Id)">编辑</el-button>
                <el-button type="text" size="small" @click="delDetail(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
          </el-col>
        </el-row>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!-- 考核明细详情界面 -->
    <el-dialog style="width: 750px; margin: 0 auto;" title="提示" :visible.sync="detailVisible" width="80%"
      :destroy-on-close="true">
      <CheckDetail :value="this.detailInfo" :key="detailInfoKey" @submit-success="refDetailTableData"
        @colse-Detail="detailVisible = false"></CheckDetail>
    </el-dialog>
  </div>
</template>

<script>
import CheckDetail from "./CheckDetail.vue";
import util from "../../../util/date";
import {
  GetChecks,
  Getcheckmodules,
  GetCheckPointLs,
  GetCheckPointParticulars,
  GetCheckPointStIndex,
  DeleteCheckPointByIds,
  AddCheckPoint,
  PutCheckPoint,
  //考核细项
  GetCheckDetailParticulars,
  DeleteCheckDetailByIds,
} from "../../api/RatingManage/RatingManage";
import {
  GetDepartmentList,
  getUsers,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
export default {
  components: {
    CheckDetail,
    Toolbar,
  },
  data() {
    return {
      filters: {
        name: "",
      },
      checks: [],
      modules: [], //存储所有可选的模块
      checkPoints: [],
      checkDetails: [],
      depts:[],
      users: [],
      detailInfo: {
        Id: '',
        StIndex: '',
        ReviewMethod: '',
        Score: 0,
        ModuleId: '',
        ItemId: '',
        SortId: '0',
        PrimaryDepartments: [],
        AssistDepartments: [],
        isEdit: false,
      },
      defCheck: 0,
      defModule: 0,
      total: 0,
      buttonList: [],
      currentRows: [],
      page: 1,
      pageSize: 10,
      detailInfoKey: Date.now(),
      listLoading: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      lookFormVisible: false, //查看界面是否显示
      lookLoading: false,
      detailListLoading: false,
      addFormRules: {
        ModuleId: [
          { required: true, message: "请输入标准序号", trigger: "blur" },
        ],
        StIndex: [
          { required: true, message: "请输入标准序号", trigger: "blur" },
        ],
        PersonLiableId: [
          { required: true, message: "请选择负责人", trigger: "blur" },
        ],
        ReviewPoints: [
          { required: true, message: "请输入评审要点", trigger: "blur" },
          { max: 500, message: '评审要点不能超过500个字符', trigger: 'blur' }
        ],
      },

      //查看界面数据
      lookForm: {
        Id: 0,
        ReviewPoints: "",
        StIndex: "",
        Score: 0,
        SortId: 0,
        CheckDetails: [],
      },
      //新增界面数据
      addForm: {
        ReviewPoints: "",
        StIndex: "",
        Score: 0,
        SortId: 0,
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        ModuleId: 0,
        ReviewPoints: "",
        StIndex: "",
        Score: 0,
        SortId: 0,
        CheckDetails: [],
      },
      detailVisible: false, //考核明细界面
      duix: "1",
    };
  },
  methods: {
    handleSelectionChange(selection) {
      this.currentRows = selection;
      console.log("AAA" + this.currentRows.length);
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    selectCurrentRow(row) {
      const isSelected = this.currentRows.includes(row);
      if (isSelected) {
        // 如果行已经选中，则取消选中
        const index = this.currentRows.indexOf(row);
        this.currentRows.splice(index, 1);
        this.$refs.multipleTable.toggleRowSelection(row, false);
      } else {
        // 如果行未选中，则添加选中
        this.currentRows.push(row);
        this.$refs.multipleTable.toggleRowSelection(row, true);
      }
    },
    customSort(a, b) {
      const getIndex = (str) => {
        // 将标准序号字符串转换为可以比较的数值
        const parts = str.split('.').map(part => parseFloat(part));
        let index = 0;
        for (let i = 0; i < parts.length; i++) {
          index += parts[i] / Math.pow(100, i);
        }
        return index;
      };

      const indexA = getIndex(a.StIndex);
      const indexB = getIndex(b.StIndex);

      if (indexA > indexB) return 1;
      if (indexA < indexB) return -1;
      return 0;
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
          new Date(row.CreateTime),
          "yyyy-MM-dd hh:mm:ss"
        );
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getCheckPointLs();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1; // 当更改分页大小时，重置为第一页
      this.getCheckPointLs();
    },
    getDeptNameById(deptId) {
      // 遍历部门数组，寻找与deptId匹配的部门对象
      for (var i = 0; i < this.depts.length; i++) {
        if (this.depts[i].key === deptId) {
          return this.depts[i].label; // 返回找到的部门名称
        }
      }
      return "未知部门"; // 如果找不到对应ID的部门，返回默认值或者空字符串，根据需求
    },
    async getchecks() {
      await GetChecks().then((res) => {
        this.checks = res.data.response;
        if (this.checks == null || this.checks.length === 0) {
          this.$message({
            type: 'warning',
            message: '请先创建考核'
          });
          return
        }
        else
          this.defCheck = this.checks[0].Id;

      });
    },
    async getchekmodules() {
      let para = {
        checkId: this.defCheck,
      };
      await Getcheckmodules(para).then((res) => {
        this.modules = res.data.response;
        if (this.modules == null || this.modules.length === 0) {
          this.$message({
            type: 'warning',
            message: '当前考核还未创建考核模块，请先创建模块。'
          });
        }
        this.defModule = 0;
        this.getCheckPointLs();
      });
    },
    async getDeptList() {
      await GetDepartmentList().then((res) => {
        if (res.status == 200) {
          res.data.response.forEach((element) => {
            this.depts.push({ key: element.Id, label: element.Name, uid: element.Uid });
          });
        }
      });
    },
    getUsersQuery() {
      getUsers().then((res) => {
        if (res.data.success) {
          this.users = res.data.response;
        }
      });
    },
    checkChange() {
      this.page = 1;
      this.getchekmodules();
    },
    moduleChange() {
      this.page = 1;
      this.getCheckPointLs();
    },
    getAddStIndex(moduleId) {
      GetCheckPointStIndex({ moduleId }).then((res) => {
        this.addForm.StIndex = res.data.response;
      });
    },
    getEditStIndex(moduleId) {
      GetCheckPointStIndex({ moduleId }).then((res) => {
        this.editForm.StIndex = res.data.response;
      });
    },
    //考核项
    getCheckPointLs() {
      let para = {
        page: this.page,
        key: this.filters.name,
        pageSize: this.pageSize,
        checkId: this.defCheck,
        moduleId: this.defModule,
      };
      this.listLoading = true;
      GetCheckPointLs(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.checkPoints = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    customHandleSearch(val) {
      this.filters = {
        name: val,
      };
      this.getCheckPointLs();
    },
    handleLook(Id) {
      let para = { pointId: Id };
      GetCheckPointParticulars(para).then((res) => {
        this.lookForm = res.data.response;
        this.checkDetails = this.lookForm.CheckDetails;
      });
      this.lookFormVisible = true;
    },
    handleAdd() {
      this.addForm = {
        ReviewPoints: "",
        StIndex: "",
        Score: 0,
        SortId: 0,
      };
      this.addFormVisible = true;
    },
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            AddCheckPoint(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getCheckPointLs();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    handleDel(row) {
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该考核项?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = [row.Id];
          DeleteCheckPointByIds(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.getCheckPointLs();
          });
        })
        .catch(() => { });
    },
    handleDels() {
      let rows = this.currentRows;
      if (!rows || rows.length === 0) {
        this.$message({
          message: "请选择要删除的数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除选中的考核项吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = rows.map((row) => row.Id);
          DeleteCheckPointByIds(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.currentRows = [];
              this.$refs.multipleTable.clearSelection();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.getCheckPointLs();
          });
        })
        .catch(() => { });
    },
    handleEdit(row) {
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      let para = { pointId: row.Id };
      GetCheckPointParticulars(para).then((res) => {
        this.editForm = res.data.response;
        this.checkDetails = this.editForm.CheckDetails;
        this.editForm.PersonLiableId =this.editForm.PersonLiableId==="0"?null:this.editForm.PersonLiableId;
      });
      // 将选中行数据复制到编辑表单中
      //this.editForm = Object.assign({}, row);
      // 控制编辑表单的显示
      this.editFormVisible = true;
    },
    editSubmit: function () {
      //保存
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            this.editForm.CheckDetails = [];
            let para = Object.assign({}, this.editForm);
            PutCheckPoint(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getCheckPointLs();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //考核细项
    refDetailTableData(id) {
      let para = { pointId: id };
      this.detailListLoading = true;
      GetCheckPointParticulars(para).then((res) => {
        this.checkDetails = res.data.response.CheckDetails;
        this.detailListLoading = false;
        this.detailVisible = false;
      });
    },
    addDetail(moduleId, itemId) {
      this.detailInfo = {
        Id: '',
        StIndex: '',
        ReviewMethod: '',
        Score: 0,
        ModuleId: moduleId,
        ItemId: itemId,
        SortId: '0',
        primaryDepartments: [],
        assistDepartments: [],
        isEdit: true,
      };
      this.detailInfoKey = Date.now();
      this.detailVisible = true;
    },
    lookDetail(Id) {
      let para = { detailId: Id };
      GetCheckDetailParticulars(para).then((res) => {
        this.detailInfo = res.data;
        this.detailInfo.isEdit = false;
        this.detailInfoKey = Date.now();
        this.detailVisible = true;
      });
    },
    editDetail(Id) {
      let para = { detailId: Id };
      GetCheckDetailParticulars(para).then((res) => {
        this.detailInfo = res.data;
        this.detailInfo.isEdit = true;
        this.detailInfoKey = Date.now();
        this.detailVisible = true;
      });
    },
    delDetail(row) {
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该考核项吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.detailListLoading = true;
          //NProgress.start();
          let para = [row.Id];
          DeleteCheckDetailByIds(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.detailListLoading = false;
              return;
            }
            this.detailListLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.refDetailTableData(row.ItemId);
          });
        })
        .catch(() => { });
    },
    async setup() {
      await this.getchecks();
      await this.getchekmodules();
      this.getDeptList();
      this.getUsersQuery();
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList(this.$route.path, routers);
    },
  },
  mounted() {
    this.setup();
  },
};
</script>